export default "__VITE_ASSET__24bed5ac__"